import { mapState } from 'vuex';
import numeral from 'numeral';
import prettyMs from 'pretty-ms';
import store from '@/store';
import config from '@/helpers/config';
import { shorten, etherscanLink } from '@/helpers/utils';

// @ts-ignore
const modules = Object.entries(store.state).map(module => module[0]);

import asset_list from '@/data/asset_list.js'

export default {
  data() {
    return {
      config
    };
  },
  computed: {
    ...mapState(modules)
  },
  methods: {

    historyBack(){
      window.history.back()
    },

    // trans horse data
    transHorseData(input,obj_race_inofo){

      

      let v = this

      let res = Object.assign({},input)
      console.log(input)

      
      // console.log('transHorseData')
      // console.log(res)

      res.horse_color = `rgba(${parseInt(input.coatcolourR)},${parseInt(input.coatcolourG)},${parseInt(input.coatcolourB)},1)`
      res.horse_name = res.name || 'Lion'
      res.item_name = res.name || 'Lion'

      res.tokenID = res.tokenID || res.tokenId || undefined
      res.tokenId = res.tokenId || res.tokenID || undefined

      res.auctionInfo = res.auctionInfo || {}
      res.auctionInfo.price_token = 'JGN'
      res.auctionInfo.price = res.auctionInfo.price || '-'
      
      res.horseRaceInfo = res.horseRaceInfo || obj_race_inofo || {}
      let temp_win_rate = res.horseRaceInfo.racesNumber ? res.horseRaceInfo.firstNumber / res.horseRaceInfo.racesNumber : 0
      res.horse_win_rate = (temp_win_rate * 100).toFixed(0) + '%'

      // male
      // console.log('transHorseMale')
      res.parent_male = 
        (res.sire && (res.sire.tokenID || res.sire.tokenID == 0)) ?
        v.transHorseData(res.sire, res.sire_horseRaceInfo) : {}

      // female
      // console.log('transHorseFemale')
      res.parent_female = 
        (res.matron && (res.matron.tokenID || res.matron.tokenID == 0)) ?
        v.transHorseData(res.matron, res.matron_horseRaceInfo) : {}

      // subspring
      // console.log('transHorseSubspring')
      // console.log(res.offsprings)
      res.child_list = (res.offsprings && res.offsprings.length > 0) ? 
        res.offsprings.map(i => {
          return v.transHorseData(i.horse, i.horseRaceInfo)
        }) : []

      return res
    },
    
    // 传参如 0.5 DAI
    calcValueOnUsd(num,token_id){
      let id = asset_list.find(i => i.id === token_id).query_id_for_exchange_price

      let price_usd = ((store as any).state.data.price_on_usd[id] || {}).usd || 0
      return num * price_usd
    },
    // 传参如： 0.5 DAI ETH（09.5个DAI值多少ETH）
    calcValueOnToken(num_token_a, token_id_a, token_id_b) {

      let id_a = asset_list.find(i => i.id === token_id_a).query_id_for_exchange_price
      let id_b = asset_list.find(i => i.id === token_id_b).query_id_for_exchange_price

      let price_a_on_usd = ((store as any).state.data.price_on_usd[id_a] || {}).usd || 0
      let price_b_on_usd = ((store as any).state.data.price_on_usd[id_b] || {}).usd || 0

      return num_token_a * price_a_on_usd / price_b_on_usd
    },

    _ms(number) {
      const diff = number * 1e3 - new Date().getTime();
      return prettyMs(diff);
    },
    _numeral(number, format = '(0.[00]a)') {
      return numeral(number).format(format);
    },
    _shorten(str: string, key: string): string {
      let limit;
      if (key === 'symbol') limit = 6;
      if (key === 'name') limit = 64;
      if (key === 'choice') limit = 12;
      if (limit)
        return str.length > limit ? `${str.slice(0, limit).trim()}...` : str;
      return shorten(str);
    },
    _etherscanLink(str: string, type: string): string {
      return etherscanLink(str, type);
    }
  }
};
